module.exports = __webpack_public_path__ + "img/shoulder width.12c709f3.png";